import { HttpService } from "../HttpService";
import { useGetAuthorizationStore } from "../modules/authentication/infrastructure/useGetAuthorizationStore";

const host = process.env.REACT_APP_API_URL || `${window.location.origin}/api/`;

const httpService = () => {
  const tokenSecurity = useGetAuthorizationStore.getState().tokenSecurity;
  return new HttpService({
    host,
    ...(tokenSecurity
      ? {
          headers: {
            "X-Access-Token": `Bearer ${tokenSecurity}`,
          },
        }
      : {}),
  });
};

export { httpService, host };
